import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=59743794&scoped=true"
import script from "./AddCourse.vue?vue&type=script&lang=js"
export * from "./AddCourse.vue?vue&type=script&lang=js"
import style0 from "./AddCourse.vue?vue&type=style&index=0&id=59743794&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59743794",
  null
  
)

export default component.exports